import ISLAND_ABI from 'abis/island.json'
import { Abi, Address } from 'viem'

import { useVaultUnderlyingData, VaultUnderlyingData } from './useVaultUnderlyingData'

export type IslandUnderlyingData = VaultUnderlyingData

export interface IslandUnderlyingOptions {
  enabled?: boolean
}

export function useIslandUnderlyingBalances(islandAddresses: Address[], options?: IslandUnderlyingOptions) {
  const {
    data: underlyingBalances,
    isLoading,
    error,
  } = useVaultUnderlyingData(islandAddresses, {
    totalSupply: {
      abi: ISLAND_ABI as Abi,
    },
    balances: {
      functionName: 'getUnderlyingBalances',
    },
    enabled: !!options?.enabled,
    logFailures: true,
  })

  return {
    data: underlyingBalances,
    isLoading,
    error,
  }
}
